enum DirectoryStatus {
  Submit = 'Submit for Directory Review',
  Pending = 'Pending for Directory Review',
  Approved = 'Approved for Directory',
}

export default DirectoryStatus;
